import { ReactNode } from "react";
import { branding } from "../../resources";
import { Button } from "../../components/Buttons";
import { AuthContextInterface } from "@surveying-hub-bv/fe-component-library";
import { Link, useNavigate } from "react-router-dom";
import EagerSVGIcon from "../../components/EagerSVG";
import { useTranslation } from "react-i18next";

type HeaderWithSidebarProps = {
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
    topLogo: ReactNode
    loginUrl: string | (() => void)
    loggedIn?: AuthContextInterface
    isLoggedIn: boolean
    isMobile: boolean
}
export const HeaderWithSidebar = ({ isOpen, setIsOpen, topLogo, loginUrl, loggedIn, isLoggedIn, isMobile }: HeaderWithSidebarProps) => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    return (
        <header
            className={`sticky inset-x-0 z-30 flex items-center md:justify-between gap-x-3 border-b dark:bg-darkMode-layer1color dark:border-darkMode-layer1border pl-4 ${isOpen ? "md:pl-72" : "md:pl-24"} pr-4 h-[68px] md:pr-8`}
            style={{ top: "var(--notif-height, 0px)" }}
        >
            {/* Hamburger Icon --- Mobile only */}
            <button
                className="md:hidden z-50 flex flex-col justify-center items-center w-8 h-8 bg-white dark:bg-darkMode-layer1color order-1"
                onClick={() => setIsOpen(!isOpen)}
                aria-label={isOpen ? "Close menu" : "Open menu"}
            >
                <span
                    className={`block h-0.5 w-6 bg-black dark:bg-white transition-transform duration-300`}
                />
                <span
                    className={`block h-0.5 w-6 bg-black dark:bg-white my-1 transition-opacity duration-300`}
                />
                <span
                    className={`block h-0.5 w-6 bg-black dark:bg-white transition-transform duration-300`}
                />
            </button>

            {/* Logo */}
            <div className={`flex items-center flex-shrink gap-x-3 order-3 md:order-2 ml-auto md:ml-0 ${isMobile ? "ml-4" : ""}`}>

                {topLogo}

            </div>

            {/* Header Links */}
            <div className="flex items-center gap-x-4 order-2 md:order-3">
                <Link
                    to="/marketplace"
                    className="flex items-center flex-shrink-0 dark:text-darkMode-primary border dark:border-darkMode-primary hover:dark:bg-darkMode-primary text-[14px] hover:dark:text-black transition-all duration-200 py-[7px] px-2 rounded-[12px] mr-auto md:mr-0"
                >
                    <EagerSVGIcon name="MarketplaceIcon" width={24} height={24} />
                    {!isMobile && (
                        <span className="ml-2 text-[14px]">
                            {t("navigation.networkCoverage")}
                        </span>
                    )}
                </Link>
                {!isLoggedIn && (
                    <Button
                        label={t("auth.logIn")}
                        onClick={() => {
                            if (loggedIn) {
                                loggedIn.logout()
                            } else if (loginUrl instanceof Function) {
                                loginUrl();
                            } else {
                                navigate('/login');
                            }
                        }}
                        buttonCustomClasses={`ml-auto ${isMobile ? "hidden" : ""}`}
                        alwaysFitWidth
                    />
                )}
            </div>
        </header>
    )
}


export const HeaderWithoutSidebar = () => {
    return (
        <header
            className={`sticky inset-x-0 z-30 flex items-center justify-between border-b dark:bg-darkMode-layer1color dark:border-darkMode-layer1border pl-4 pr-4 md:pr-8 py-2 md:py-5`}
            style={{ top: "var(--notif-height, 0px)" }}
        >
            {/* Logo */}
            <a href="/" className="flex items-center gap-x-3">
                <img src={branding.logoIcon} alt="logo" className="w-[25px] xl:w-[30px]" />

                <p className="uppercase text-[18px] xl:text-[20px]">
                    <span className="dark:text-darkMode-primary mr-1 font-medium">{branding.brandName}</span> {branding.brandName2nd}
                </p>
            </a>
        </header>
    )
}
